<div class="login-box">  
  <h2>Prijava</h2>
  <form id="login-form">
    <div class="user-box">
      <input type="text" name="username" id="username" required autocomplete="current-username">
      <label>Uporabniško ime</label>
    </div>
    <div class="user-box">
      <input type="password" name="password" id="password" required autocomplete="current-password">
      <label>Geslo</label>
    </div>
    <button type="submit" id="login-button" (click)="onLoginClick($event)">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      Prijava
    </button>
  </form>
</div>
<div *ngIf="infoDialogOpen" class="info-dialog">
  <div class="dialog-content">
    <h3>{{infoDialogTitle}}</h3>
    <p>{{infoDialogMessage}}</p>
    <button (click)="infoDialogOpen = false">V redu</button>
  </div>
</div>